/**
 * @file paddle hub 详情的版本部分
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useEffect, useMemo, useState} from 'react';
import {Select} from 'antd';
import compareVersions from 'compare-versions';

import MarkdownContainer from '../../../../components/markdown-container/MarkdownContainer';

import {
    IPaddleHubDetailMarkdownInfoItem,
    IVersionListItem
} from '../../type.d';


export interface IProps {
    info: IPaddleHubDetailMarkdownInfoItem[];
}

const PaddleHubDetailVersion: React.FC<IProps> = props => {
    const info = props.info;
    const [version, setVersion] = useState<string>('');

    const versionList = useMemo((): IVersionListItem[] => {
        const list: IVersionListItem[] = (info ?? []).map(item => ({
            version: item.version,
            text: item.version
        }));
        // 版本按照从大到小排序
        const sortList = list.sort((a, b) =>
            compareVersions(b.version, a.version)
        );
        if (sortList.length > 0) {
            sortList[0].text = `${sortList[0].text} (最新版)`;
        }
        return sortList;
    }, [info]);

    useEffect(() => {
        if (!version && versionList.length > 0) {
            setVersion(versionList[0].version);
        }
    }, [version, versionList, info]);

    const selectedInfoItem = info.find(item => item.version === version);

    return (
        <div className="paddle-hub-detail-version">
            <div className="paddle-hub-detail-version-selector-wrap">
                {
                    versionList.length > 0
                    && <Select
                        size="large"
                        className="paddle-hub-detail-version-selector"
                        value={version}
                        onChange={setVersion}
                    >
                        {versionList.map(item => (
                            <Select.Option key={item.version} value={item.version}>
                                {item.text}
                            </Select.Option>
                        ))}
                    </Select>
                }
            </div>
            {
                !!selectedInfoItem
                && <MarkdownContainer
                    key={selectedInfoItem.md5}
                    source={selectedInfoItem.detail}
                />
            }
        </div>
    );
};

export default PaddleHubDetailVersion;
